// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"3c48c231","225":"2a836ab7","272":"db45d1a3","372":"dc24204c","377":"3b9fa485","521":"c6d0861f","573":"e92aecce","738":"44b93b68","841":"ce8d8f58","856":"07ef9964","862":"09cec2d6"}[chunkId] + ".chunk.js";
};